import { ASSESSMENT_REPORT_V2_QUESTIONS, CONSULTATION_REPORT_V2_QUESTIONS, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS, TREATMENT_SUMMARY_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty } from "helpers/common";
import { dateRequiredSchema, numberRequiredSchema, stringLengthSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, number, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
    switch (currentTab) {
        case 1:
            return object().shape({
                screening_date: date()
                    .nullable()
                    .required('Screening date is required'),
            });
        case 2:
            //   const locationQuestion = getQuestionById(INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location, reportQuestions);
            //   const inputLabels = locationQuestion?.question_dd_labels || [];
            //   const labelsValidation = {};
            //   inputLabels?.length && inputLabels.forEach(label => {
            //     labelsValidation[label] = stringRequiredSchema;
            //   })

            return object({
                [TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.diagnosis]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                [TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.background]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                [TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.additionalInformation]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
            });
        case 3:
            return object().shape({
                assessment_plans: array().of(
                    object().shape({
                        summary: object().shape({
                            answer: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        }),
                        diagnosis_severity: object().shape({
                            answer: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        })
                    })
                ),
            });

        case 4:
            return object().shape({
                goals: array().of(
                    object().shape({
                        show_tracker: string().nullable(),
                        goal_date: dateRequiredSchema,
                        status: object().shape({
                            value: numberRequiredSchema,
                            label: stringRequiredSchema
                        }).required('This field is required'),
                        scores: array()
                            .of(number().nullable().transform(v => (v === "" ? null : v)))
                            .when('show_tracker', {
                                is: 'show',
                                then: (schema) => schema.test(
                                    "at-least-one-positive",
                                    "Please fill at least one goal",
                                    (arr) => arr?.some((num) => num > 0)
                                ),
                                otherwise: (schema) => schema,
                            }),
                        goal_notes: string()
                            .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                            .required('This field is required'),
                        strategy: array().of(object().shape({
                            answers: string(),
                        })),
                    })
                ).min(1, "Atleast 1 goal is required.")// Add this

            });

        case 5:
            return object().shape({
                treatment_plans: array().of(
                    object().shape({
                        area_id: object().shape({
                            value: numberRequiredSchema,
                            label: stringRequiredSchema
                        }).required('This field is required'),
                        goal_id: object().shape({
                            value: numberRequiredSchema,
                            label: stringRequiredSchema
                        }).required('This field is required'),
                        AssessmentGoalStrategyData: array().of(object().shape({
                            answers: string()
                                .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                                .required('This field is required'),
                        })).min(1, "Atleast 1 strategy is required."),
                    })
                ),
            });
        case 6:
            return object({
                [TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.summary]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                [TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.clinical_impressions]: object({
                    answer: string()
                        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                        .required('This field is required'),
                }),
                recommendation: array().of(
                    object().shape({
                        answers: string()
                            .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
                            .required('This field is required'),
                    })
                ),
            });
    }
}

export default getValidationSchema;
